// src/auth/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import roleHome from './roleHome';

// requiredRole: a single role. allowRoles: several roles, e.g. ['therapist', 'intake_worker'].
export default function ProtectedRoute({ children, requiredRole, allowRoles }) {
    const { isAuthenticated, isLoading, user } = useAuth();

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '1.5rem',
                color: '#666'
            }}>
                Loading...
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    const allowed = allowRoles || (requiredRole ? [requiredRole] : null);
    if (allowed && !allowed.includes(user?.role)) {
        // Redirect to the correct page based on role
        return <Navigate to={roleHome(user?.role)} replace />;
    }

    return children;
}
